import React, { useMemo } from 'react';
import {
  FormControl,
  TextField,
  Autocomplete,
} from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { funcionarioService } from '../../services/funcionario';

interface SelectFuncionarioProps {
  value: number;
  onChange: (value: number) => void;
  label?: string;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  fullWidth?: boolean;
}

const SelectFuncionario: React.FC<SelectFuncionarioProps> = ({
  value,
  onChange,
  label = 'Funcionário',
  required = false,
  error = false,
  helperText,
  disabled = false,
  fullWidth = true,
}) => {
  const { data: funcionarios = [], isLoading } = useQuery({
    queryKey: ['funcionarios'],
    queryFn: () => funcionarioService.getAll(),
  });

  const sortedFuncionarios = useMemo(
    () =>
      [...funcionarios].sort((a, b) =>
        a.nome.localeCompare(b.nome, 'pt-BR', { sensitivity: 'base' })
      ),
    [funcionarios]
  );

  const selected = useMemo(
    () => sortedFuncionarios.find((f) => f.id === value) || null,
    [sortedFuncionarios, value]
  );

  return (
    <FormControl
      fullWidth={fullWidth}
      required={required}
      error={error}
      disabled={disabled}
    >
      <Autocomplete
        options={sortedFuncionarios}
        getOptionLabel={(f) => f.nome}
        isOptionEqualToValue={(a, b) => a.id === b.id}
        value={selected}
        onChange={(_, newValue) => onChange(newValue?.id || 0)}
        disabled={disabled}
        loading={isLoading}
        loadingText="Carregando..."
        noOptionsText="Nenhum funcionário encontrado"
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            required={required}
            error={error}
            helperText={helperText}
          />
        )}
      />
    </FormControl>
  );
};

export default SelectFuncionario;
